import {useFeatureFlag} from '@malt/feature-flags';
import type {JoyIconsId} from '@maltjoy/icons';

const PLACEHOLDER_ICON = 'company-placeholder';

const familyLogo: Record<string, JoyIconsId> = {
    business_consulting: 'company-placeholder',
    communication: 'communication',
    data: 'dataviz',
    industrial_engineering: 'r2d2',
    marketing: 'marketing',
    other: 'three-dots',
    picture_sound: 'play',
    projectmanagers_agilecoaches: 'projectmanager-agile',
    support_functions: 'users',
    tech: 'xml',
    video_games: 'videogame',
    web_graphic_design: 'web-design',
};

const oldAssociations: Record<string, JoyIconsId> = {
    business_consulting: 'fee',
    communication: 'communication',
    data: 'dataviz',
    'industrial-engineering': 'r2d2',
    marketing: 'marketing',
    other: 'dots-vertical',
    'projectmanagers-agilecoaches': 'projectmanager-agile',
    'support-functions': 'users',
    developers_datascientists: 'xml',
    'video-games': 'videogame',
    graphicdesigners_photographers: 'web-design',
};

export function useFamilyIcon() {
    const isRevampedCategorySection = useFeatureFlag('enable-category-section-revamp');

    function familyIconOf(familyId: string): JoyIconsId {
        return (isRevampedCategorySection.value ? familyLogo[familyId] : oldAssociations[familyId]) || PLACEHOLDER_ICON;
    }

    return {familyIconOf};
}
